export default __webpack_public_path__ + "static/media/Sunrise.df63c26e.jpg";